export default __webpack_public_path__ + "static/media/117_desktop.ce0e365f.jpg";